export const checksums = {
  "pages": "v3.5.0--K5i416qu9ZUO-vGCyBo1jpkwxV_U9vgJRHu8vP6A_QA",
  "menus": "v3.5.0--V8o98tX5fv-rtFk8odRNwXPjFm0EIkv6wSm9PiRIggY",
  "forms": "v3.5.0--qEDpK490G02CzTFhay0JHhNwiRW2x95KyPL3pi1ZLX4",
  "siteOptions": "v3.5.0--93rF2-3GDabvkWQaprFGZLwhKssJeid8oZDteILDe5w",
  "homeDesigns": "v3.5.0--CD5Bju56LwoBNonnGkEwd4Out0W9rHdX3YPVGhBzvm8",
  "posts": "v3.5.0--0NTs9dtR9nzoL8f6SPVnVqiNcRPoA4X0-CRuCbje-tU",
  "houseLandPackages": "v3.5.0--k7J2zMbWU9AlHjJqMXvT2IAACgikwD-pry7hoQprm1c",
  "regions": "v3.5.0--YrGckId-ay_qfhPVCFJSC9jeX80GpGCGxVQpF5ZyvIg",
  "estates": "v3.5.0--GSbg5DjaVvmoM4lE-oF8sGF1zhQzUs3ldFU3KNV9Lb0",
  "suburbs": "v3.5.0--97Clj6c7lSoKvIF_cdCaE_zS04GolFqHGKm8erTwTxs",
  "statuses": "v3.5.0--4pXy38KpHpzmAiO9ktCkhqiBz9vNzifh3rsY1ga9_vA",
  "houseLengths": "v3.5.0---whCV8AX8dNzAqO3wZZNnAZkOSO6EdaNNcPgJfetlFk",
  "homeStyles": "v3.5.0--U1S-58g8U5VfsabBA49PtkHAUOqEVJ6UVcIK_swEDYk"
}
export const checksumsStructure = {
  "pages": "4tK-AmkEoUyTn7hL6ajN5TybyeHLSUUVXcTEpra9_yo",
  "menus": "06SY3JH0cXs6Wy7jdeCv5bYpyiVj2qIYTqIfpt8N6ZA",
  "forms": "Bjv0IEJOH46azTGoIHXMhvZsex6cfqvJjb8evbwEc_8",
  "siteOptions": "eJHQnviorChQK8wR5ApuneTcaG5gUboGzkCIpKjIF2Y",
  "homeDesigns": "wgjxzpgXbCrT6Hv4p1LhXqsrg4kmHF7A3ikzpwq2TPM",
  "posts": "d7cn_3c2MuPPQEuEfgsr324Oy_ktVqRMOXG_E2n0d04",
  "houseLandPackages": "3Mn-rgDp-Gyohwutwvp2U0rCkoxdSzN3RcvsY3-Xj74",
  "regions": "SMbfMLU8aaZ59nar5FUwyu1-mXFMclOx1pyu3X_YIgk",
  "estates": "QtzotwCmWeD4kw5KmkMh7nAe9m6Y3EbqYjG9WuccEhc",
  "suburbs": "fho288pw2cO_zM13TVBWbT-2v0XksMyEHshXGNcq0JU",
  "statuses": "IgBV3G5HFKvy671ABmF3XdLUan1RxvPCx3ul31GJx7Q",
  "houseLengths": "RzpGo32CIi_Q-c51LB2VWxh1_wAlQl-srbY_b3vnAbw",
  "homeStyles": "IzfBP72WmVbMWywCX3uhICbgDyS8WxFmnHzwKgFXVUs"
}

export const tables = {
  "pages": "_content_pages",
  "menus": "_content_menus",
  "forms": "_content_forms",
  "siteOptions": "_content_siteOptions",
  "homeDesigns": "_content_homeDesigns",
  "posts": "_content_posts",
  "houseLandPackages": "_content_houseLandPackages",
  "regions": "_content_regions",
  "estates": "_content_estates",
  "suburbs": "_content_suburbs",
  "statuses": "_content_statuses",
  "houseLengths": "_content_houseLengths",
  "homeStyles": "_content_homeStyles",
  "info": "_content_info"
}

export default {
  "pages": {
    "type": "data",
    "fields": {
      "id": "string",
      "body": "json",
      "extension": "string",
      "meta": "json",
      "stem": "string",
      "uri": "string"
    }
  },
  "menus": {
    "type": "data",
    "fields": {
      "id": "string",
      "body": "json",
      "extension": "string",
      "meta": "json",
      "slug": "string",
      "stem": "string"
    }
  },
  "forms": {
    "type": "data",
    "fields": {
      "id": "string",
      "body": "json",
      "extension": "string",
      "formId": "string",
      "meta": "json",
      "stem": "string"
    }
  },
  "siteOptions": {
    "type": "data",
    "fields": {
      "id": "string",
      "acfKey": "string",
      "body": "json",
      "extension": "string",
      "meta": "json",
      "stem": "string"
    }
  },
  "homeDesigns": {
    "type": "data",
    "fields": {
      "id": "string",
      "body": "json",
      "date": "string",
      "extension": "string",
      "meta": "json",
      "slug": "string",
      "stem": "string",
      "uri": "string"
    }
  },
  "posts": {
    "type": "data",
    "fields": {
      "id": "string",
      "body": "json",
      "date": "string",
      "extension": "string",
      "meta": "json",
      "slug": "string",
      "stem": "string",
      "uri": "string"
    }
  },
  "houseLandPackages": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "extension": "string",
      "featuredImage": "json",
      "houseAndLandPackageFields": "json",
      "meta": "json",
      "seo": "json",
      "slug": "string",
      "stem": "string",
      "uri": "string"
    }
  },
  "regions": {
    "type": "data",
    "fields": {
      "id": "string",
      "databaseId": "number",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "slug": "string",
      "stem": "string"
    }
  },
  "estates": {
    "type": "data",
    "fields": {
      "id": "string",
      "databaseId": "number",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "slug": "string",
      "stem": "string"
    }
  },
  "suburbs": {
    "type": "data",
    "fields": {
      "id": "string",
      "databaseId": "number",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "slug": "string",
      "stem": "string"
    }
  },
  "statuses": {
    "type": "data",
    "fields": {
      "id": "string",
      "databaseId": "number",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "slug": "string",
      "stem": "string"
    }
  },
  "houseLengths": {
    "type": "data",
    "fields": {
      "id": "string",
      "databaseId": "number",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "slug": "string",
      "stem": "string"
    }
  },
  "homeStyles": {
    "type": "data",
    "fields": {
      "id": "string",
      "body": "json",
      "date": "string",
      "extension": "string",
      "meta": "json",
      "slug": "string",
      "stem": "string",
      "type": "json",
      "uri": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}